export default __webpack_public_path__ + "static/drop-in-837f53a30ad53c882454f713b89ee6ab.png";